import { createContext } from 'react';

import { WorkItem } from '@totem/components/surveyV2/work/types';

interface Context {
  data: WorkItem[];
  setData: (data: WorkItem[]) => void;
  loading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

export default createContext<Context>({
  data: null,
  setData: () => {},
  loading: false,
  setIsLoading: () => {},
});
